module.exports = __webpack_public_path__ + "static/media/ee.266e4a5c.svg";